import {defaultPreset} from "../../components/settings/presets"

export default function BusControlIcon() {
    const PRIMARY_COLOR = defaultPreset.main

    const pathSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 24 24">' +
        '<path fill="{{primaryColor}}" d="M4 16c0 .88.39 1.67 1 2.22v1.28c0 .83.67 1.5 1.5 1.5S8 20.33 8 19.5V19h8v.5c0 .82.67 1.5 1.5 1.5c.82 0 1.5-.67 1.5-1.5v-1.28c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17m9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5m1.5-6H6V6h12z"/></svg>'

    const header = 'data:image/svg+xml,'
    const svgColorized = pathSVG
        .replace("{{primaryColor}}", PRIMARY_COLOR)

    return header + encodeURIComponent(svgColorized)
}